import { HtmlTitle } from '@app/components/html';
import { useAuth0 } from '@auth0/auth0-react';
import { useQueryParam } from '@mi-front/core';
import { Box } from '@mui/material';
import { useEffect } from 'react';
import { useIntl } from 'react-intl';
import { useHistory } from 'react-router-dom';
import { LoginIntro } from './components/LoginIntro';
import { LoginPanel } from './components/LoginPanel';

export function LoginPage() {
  const { $t } = useIntl();
  const redirectTo = useQueryParam('redirect_to');
  const { isAuthenticated } = useAuth0();
  const history = useHistory();

  // Redirect to home or intended destination if already authenticated
  useEffect(() => {
    if (isAuthenticated) {
      history.push(redirectTo || '/');
    }
  }, [isAuthenticated, redirectTo, history]);

  // Don't render login form if already authenticated (will redirect)
  if (isAuthenticated) {
    return null;
  }

  return (
    <Box display="flex" className="vh-100">
      <HtmlTitle
        text={$t({
          id: 'auth.loginScreen.title',
          defaultMessage: 'Login',
        })}
      />
      <LoginPanel />
      <LoginIntro />
    </Box>
  );
}
